import type { RouteComponentProps } from "react-router-dom"
import TaskReportedHours from "../../../tasks/components/TaskReportedHours"
import { useTask } from "../../../tasks/hooks/use-task"

type RouteParams = { taskId: string }

const queryOptions = { refetchOnMountOrArgChange: true } as const

const TaskReportedHoursRoute = ({ match }: RouteComponentProps<RouteParams>) => {
  const { task } = useTask(match.params.taskId, queryOptions)

  if (!task) return null

  return <TaskReportedHours task={task} />
}

export default TaskReportedHoursRoute
